"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("swiper/swiper.scss");
require("swiper/components/navigation/navigation.scss");
require("swiper/components/scrollbar/scrollbar.scss");
require("swiper/components/pagination/pagination.min.css");
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var SuccessStory_png_1 = __importDefault(require("../../assets/SuccessStory.png"));
function Spotlight() {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.spotlight }, { children: [(0, jsx_runtime_1.jsx)("div", { className: index_module_scss_1.default.overlay }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.content }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: "Success Story" }), (0, jsx_runtime_1.jsx)("img", { src: SuccessStory_png_1.default })] }) })) }))] })));
}
exports.default = Spotlight;
